import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const skipLink = document.querySelector(".evitement");
    

    if (skipLink) {
        skipLink.focus() // remettre le focus sur le lien d'évitment car react est un SPA single page app 
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
